import { LocationMarkerIcon, MailIcon } from '@heroicons/react/outline';
import { ActionFunction, redirect } from "@remix-run/node";
import { useSubmit } from '@remix-run/react';
import { withZod } from "@remix-validated-form/with-zod";
import { ValidatedForm, validationError } from "remix-validated-form";
import { z } from "zod";
import { zfd } from "zod-form-data";
import Footer from "~/components/LandingFooter";
import Header from "~/components/LandingHeader";
import ValidatedInput from '~/components/ValidatedInput';
import ValidatedSubmitButton from '~/components/ValidatedSubmitButton';
import ValidatedTextArea from '~/components/ValidatedTextArea';
import { Contact, createContact } from "~/models/contact.server";
import { commit, getSession, setSuccessMessage } from "~/session.server";
import banner from "~/assets/images/landing/contact/c-1.jpg";


const required: string = "This field is required"

export const validator = withZod(
    zfd.formData({
        name: zfd.text(z.string({ required_error: required })),
        email: zfd.text(z.string({ required_error: required })),
        phone: zfd.text(z.string().optional()),
        message: zfd.text(z.string().optional()),
        // token: zfd.text(z.string().optional()),
    })
);

export const action: ActionFunction = async ({ request }) => {
    let session = await getSession(request);

    const result = await validator.validate(
        await request.formData()
    );


    if (result.error) {
        // validationError comes from `remix-validated-form`
        return validationError(result.error);
    }

    // console.log("FormData", result.data);

    await createContact(result.data as Contact, "CONTACT");

    setSuccessMessage(session, 'Thank you for reaching out to us. You\'ll be contacted by our team shortly.');
    return redirect("/", { headers: { "Set-Cookie": await commit(session) } });
};

export default function About() {

    const submit = useSubmit();

    return (
        <>
            <Header />
            <div className="relative bg-white">
                <div className="lg:absolute lg:inset-0 lg:left-1/2">
                    <img
                        className="h-64 w-full bg-gray-50 object-cover sm:h-80 lg:absolute lg:h-full object-cover"
                        src={banner}
                        alt=""
                    />
                </div>
                <div className="pb-24 pt-16 sm:pb-32 sm:pt-24 lg:mx-auto lg:grid lg:max-w-7xl lg:grid-cols-2 lg:pt-32">
                    <div className="px-6 lg:px-8">
                        <div className="mx-auto max-w-xl lg:mx-0 lg:max-w-lg">
                            <h2 className="text-4xl leading-8 tracking-tight text-lcolor-200 font-bold">Let's work together</h2>
                            <p className="mt-4 mb-8 text-lg text-lcolor-500">
                                It's easy to get in touch these days. Either fill in the form below or email us at hello@bymindside.com
                            </p>
                            <ValidatedForm validator={validator} method="post" onSubmit={async (data, event) => {
                                // Data is an object with a `name` property
                                // of type `string` because of the validator above.
                                event.preventDefault();
                                // return new Promise((res, rej) => {
                                //     grecaptcha.enterprise.ready(function () {
                                //         grecaptcha.enterprise.execute('6Ld0VVMpAAAAAFRNzJy98PxNeLB66Zo6QWooOfge', { action: 'CONTACT' }).then(function (token) {

                                //             return res(token);
                                //         });
                                //     });
                                // }).then(token => {
                                    submit({ ...data }, { method: "POST", replace: true });
                                // });
                            }}>
                                <div className="grid grid-cols-1 gap-y-6">
                                    <ValidatedInput
                                        name='name'
                                        label='Full Name'
                                        type='text'
                                        required
                                    />
                                    <ValidatedInput
                                        name='email'
                                        label='Email'
                                        type='text'
                                        required
                                    />
                                    <ValidatedInput
                                        name='phone'
                                        label='Phone'
                                        type='text'
                                        desc='Optional'
                                    />
                                    <ValidatedTextArea
                                        name='message'
                                        label='How can we help you?'
                                        desc='Max 500 characters' />
                                    <p className='text-xs text-gray-500'>This site is protected by reCAPTCHA and the Google
                                        <a target="_blank" className="text-blue-700" href="https://policies.google.com/privacy"> Privacy Policy</a> and
                                        <a target="_blank" className="text-blue-700" href="https://policies.google.com/terms"> Terms of Service</a> apply.</p>
                                    <div>
                                        <ValidatedSubmitButton
                                            className="bg-lcolor-500 text-white hover:bg-lcolor-200"
                                            submit="Send message"
                                            submitting="Please wait..."
                                        />
                                    </div>
                                </div>
                            </ValidatedForm>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
}